<div *ngIf="value !== null" class="boolean-view-container">
    <div *ngIf="label" class="label">{{ label }}:</div>
    <div class="value">{{ value ? 'Yes' : 'No' }}</div>
  </div>  
  
  
  